import { RequestService } from 'Utils/Api';
import { getDefaultConfig } from 'Utils/Store';
import { logger } from 'Utils/Logger';

/*
The config repo accessed here is at https://github.com/foxcorp/cpe-client-config/tree/master
E.g. qa footer is at https://github.com/foxcorp/cpe-client-config/blob/master/foxnation/web/footer-qa.json
NATWEB team helps maintain this repo
*/

export const getConfigApi = async (uri) => {
  const { configApi, configApiSuffix } = getDefaultConfig();
  logger.apiRequest('get config');

  try {
    const res = await RequestService.send({ url: `${configApi}${uri}${configApiSuffix}.json` });
    logger.apiResponse('get config res', res);
    return res;
  } catch (error) {
    logger.apiError('get config error', error);
    throw new Error('get config error', error);
  }
};
